import React from "react";
import { Dropdown, Menu, Tag } from "@arco-design/web-react";
import { IconCheck, IconPlus } from "@arco-design/web-react/icon";

import { hasTag } from "./fileMeta";

export const NEW_TAG_KEY = "__new__";

// The tag control that sits on a file: its current tags as removable chips,
// plus a "+" that opens the full list with the applied ones ticked. Clicking a
// name toggles it immediately — there is no save step, so tagging a file is one
// click from looking at it, rather than something you have to find.
export default function FileTagPicker({ file, allTags, onToggle, onNewTag, size }) {
    const applied = (file && file.tags) || [];

    const droplist = (
        <Menu
            onClickMenuItem={(key) => {
                if (key === NEW_TAG_KEY) {
                    onNewTag(file);
                    return;
                }
                onToggle(file, key, !hasTag(file, key));
            }}
            style={{ maxHeight: 280, overflow: "auto" }}
        >
            {allTags.map((t) => (
                <Menu.Item key={t.id}>
                    <IconCheck
                        style={{
                            marginRight: 6,
                            // Held in place rather than removed, so the names
                            // don't shuffle sideways as you tick them.
                            visibility: hasTag(file, t.id) ? "visible" : "hidden",
                        }}
                    />
                    {t.name}
                </Menu.Item>
            ))}
            {allTags.length > 0 && (
                <Menu.Item key="__divider__" disabled style={{ borderTop: "1px solid var(--color-border-2)" }} />
            )}
            <Menu.Item key={NEW_TAG_KEY}>＋ New tag…</Menu.Item>
        </Menu>
    );

    return (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 4, alignItems: "center" }}>
            {applied.map((t) => (
                <Tag
                    key={t.id}
                    size={size}
                    color={t.color || "arcoblue"}
                    closable
                    onClose={(e) => {
                        // The chip sits on a clickable card; closing it should
                        // not also open the preview behind it.
                        e.stopPropagation();
                        onToggle(file, t.id, false);
                    }}
                >
                    {t.name}
                </Tag>
            ))}
            <Dropdown droplist={droplist} trigger="click" position="bl">
                <Tag
                    size={size}
                    icon={<IconPlus />}
                    style={{ cursor: "pointer", borderStyle: "dashed", background: "transparent" }}
                >
                    {applied.length === 0 ? "Tag" : ""}
                </Tag>
            </Dropdown>
        </div>
    );
}
